import { FocusableOption } from "@angular/cdk/a11y";
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { cn } from "pax-ui/core";

import { ResponsiveText } from "../../responsive-text";
import { UncontrolledSelectOption } from "../types/uncontrolled-select-option.interface";

@Component({
  selector: "pax-uncontrolled-select-list-option",
  standalone: true,
  templateUrl: "./uncontrolled-select-list-option.html",
  imports: [ResponsiveText],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UncontrolledSelectListOption implements FocusableOption, OnInit {
  @Input({ required: true }) id!: string;
  @Input({ required: true }) option!: UncontrolledSelectOption;

  @Input() selectedValue: UncontrolledSelectOption | undefined;
  @Input() disabled: boolean = false;

  @Output() clicked = new EventEmitter();

  styles!: string;
  iconStyles!: string;

  constructor(private element: ElementRef<HTMLDataListElement>) {}

  ngOnInit() {
    this.styles = cn(
      "flex h-full w-full min-w-6 cursor-default items-center justify-between gap-x-2 px-3 py-1.5 text-gray-700",
      !this.disabled && "cursor-pointer hover:text-primary-green",
      this.disabled && "text-gray-400",
    );

    this.iconStyles = cn(
      "lucide lucide-check w-4 text-inherit",
      !this.isSelected && "hidden",
    );
  }

  handleClick() {
    this.clicked.emit(this.option.value);
  }

  focus() {
    if (!this.disabled) {
      this.element.nativeElement.querySelector("button")?.focus();
    }
  }

  getLabel() {
    return this.option.label || this.option.value;
  }

  get isSelected() {
    return this.option.value === this.selectedValue?.value;
  }
}
